import { Box, Button, Typography } from '@mui/material';
import React, { FormEventHandler, useState } from 'react';
import { useHistory } from 'react-router';

import { EntityTextField } from 'app/components/form-controls/entity-text-field';
import { DescriptorData } from 'app/model/crowd/descriptor-data';
import { crowdDescriptorService } from 'app/services/crowd-descriptor.service';
import { messagingService } from 'app/services/messaging.service';
import { EntityOnChange } from 'app/type';

export const DescriptorForm: React.FunctionComponent = () => {
    const history = useHistory();

    const [entityData, setEntityData] = useState(crowdDescriptorService.createEmptyModel());

    const handleSubmit: FormEventHandler = (evt) => {
        evt.preventDefault();
        crowdDescriptorService.save(entityData).subscribe(() => {
            messagingService.showSuccess('Thank you for your submission');
            setEntityData(crowdDescriptorService.createEmptyModel());
            history.replace('/crowd');
        });
    };

    const handleEntityUpdate: EntityOnChange<DescriptorData, unknown> = (evt, name, value) => {
        setEntityData({ ...entityData, [name]: value });
    };

    return (
        <form onSubmit={handleSubmit}>
            <Typography variant='h6'>Submit your descriptor info</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <EntityTextField
                    label='Descriptor'
                    name='descriptor'
                    className='mb-1 mr-1'
                    value={entityData}
                    onChange={handleEntityUpdate}
                />
                <EntityTextField
                    label='Merchant Name'
                    name='merchant'
                    className='mb-1 mr-1'
                    value={entityData}
                    onChange={handleEntityUpdate}
                />
                <EntityTextField
                    label='Extra Notes'
                    name='notes'
                    className='mb-1 mr-1'
                    multiline
                    rows='3'
                    value={entityData}
                    onChange={handleEntityUpdate}
                />
            </Box>

            <Button type='submit' variant='outlined' color='primary' className='mt-2'>
                Save
            </Button>
        </form>
    );
};
